// Line icons for the Controls buttons (the "Mind Map Redesign" zoom bar); they take the button's text colour.

const LINE = {
  viewBox: '0 0 24 24',
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth: 2,
  strokeLinecap: 'round' as const,
  strokeLinejoin: 'round' as const,
  'aria-hidden': true,
};

export const PlusIcon = () => (
  <svg {...LINE} strokeWidth={2.2}>
    <path d="M12 5v14M5 12h14" />
  </svg>
);

export const MinusIcon = () => (
  <svg {...LINE} strokeWidth={2.2}>
    <path d="M5 12h14" />
  </svg>
);

export const FitViewIcon = () => (
  <svg {...LINE}>
    <path d="M4 9V5a1 1 0 0 1 1-1h4M15 4h4a1 1 0 0 1 1 1v4M20 15v4a1 1 0 0 1-1 1h-4M9 20H5a1 1 0 0 1-1-1v-4" />
  </svg>
);

export const LockIcon = ({ isOpen }: { isOpen: boolean }) => (
  <svg {...LINE}>
    <rect x="5" y="11" width="14" height="10" rx="2" />
    <path d={isOpen ? 'M8 11V7a4 4 0 0 1 7.5-2' : 'M8 11V7a4 4 0 0 1 8 0v4'} />
  </svg>
);
